// Locked source of truth: 01_PEOPLE_LOCKED.pdf
// Names, dates, geography and expertise preserved verbatim. Order preserved.

export const PEOPLE_META = {
  label: "Explore · People",
  title: "People",
};

// TEAM — names and years, in source order. Closed relationships keep their year range.
export const TEAM = [
  { name: "AKHILESH B", years: "2009 -" },
  { name: "MONU", years: "2022 -" },
  { name: "RUPESH S", years: "2014 -" },
  { name: "ARJUN R", years: "2017 -" },
  { name: "MUKUL D", years: "2010 -" },
  { name: "SAGAR K", years: "2012 -" },
  { name: "ASHUTOSH G", years: "2008 -" },
  { name: "NAREN D", years: "2017-2018" },
  { name: "SAMEER B", years: "2012 -" },
  { name: "HARSHAD", years: "2021 -" },
  { name: "NIKHIL", years: "2021 -" },
  { name: "VIVEK S", years: "2021 -" },
  { name: "HRUSHIKESH C", years: "2022 -" },
  { name: "OM S", years: "2008 -" },
  { name: "AJAY Y", years: "2012 -" },
  { name: "KAILASH K", years: "2008 -" },
  { name: "PANDEY", years: "2015-" },
  { name: "GOVIND D", years: "2012 -" },
  { name: "KAUSHIK L", years: "2014 -" },
  { name: "PIPI", years: "2021 -" },
  { name: "KAUSHAL L", years: "2017-2020" },
  { name: "GANESH K", years: "2012 -" },
  { name: "RAHUL S", years: "2008-2017" },
  { name: "CAJETAN R", years: "2012 -" },
  { name: "MANISH R", years: "2012 - 2022" },
  { name: "RISHI P", years: "2015-" },
];

// ASSOCIATES & PARTNERS — name, geography, years.
export const ASSOCIATES = [
  { name: "SEHAJ J", geo: "NORTH INDIA", years: "2015-" },
  { name: "YUSUF G", geo: "PUNE & WEST", years: "2019 -" },
  { name: "SUMANTA G", geo: "KOLKATA & EAST", years: "2019 -" },
  { name: "MURTUZA M", geo: "BENGALURU & SOUTH", years: "2019 -" },
  { name: "SYED I", geo: "HYDERABAD & SOUTH", years: "2019 -" },
  { name: "PANKAJ B", geo: "GUWAHATI & NORTH EAST", years: "2019 -" },
  { name: "VISHAL B", geo: "PUNE", years: "2014 -" },
];

// BEHIND THE SCENE — name, area of expertise, years.
export const BEHIND = [
  { name: "THE NEW AHMEDABAD SPORTS", area: "EQUIPMENT / APPAREL", years: "2008 -" },
  { name: "NARIMAN SPORTS", area: "EQUIPMENT / APPAREL", years: "2008 -" },
  { name: "SELECTIONS SPORTS", area: "EQUIPMENT / APPAREL", years: "2008 -" },
  { name: "GALAXY SPORTS", area: "EQUIPMENT / APPAREL", years: "2013 -" },
  { name: "ATHLETI SPORTS", area: "APPAREL", years: "2022 -" },
  { name: "AVANI T", area: "PRINTING", years: "2008 -" },
  { name: "PRATHMESH B", area: "DESIGN", years: "2018-" },
  { name: "PRAKASH D", area: "PHOTOGRAPHY / VIDEOGRAPHY", years: "2008 -" },
  { name: "SATISH S", area: "VIDEOGRAPHY", years: "2019-" },
  { name: "GO AID", area: "AMBULANCE", years: "2021 -" },
  { name: "DR. VARUN S", area: "PHYSIO", years: "2012 -" },
  { name: "KJ TROPHY", area: "AWARDS", years: "2023 -" },
  { name: "SHUBH CREATIONS", area: "AWARDS", years: "2013-2021" },
  { name: "VENKATRAMAN I", area: "COMMENTARY", years: "2014-" },
  { name: "LADHA SINGHAL", area: "FINANCE & ACCOUNTS", years: "2008 -" },
  { name: "ZOHO BOOKS", area: "FINANCE & ACCOUNTS", years: "2017 -" },
];

// Archival photographs — used as loose documentary interruptions, not portraits.
export const ARCHIVE = [
  { src: "/people/a15.jpg", o: "land" },
  { src: "/people/a20.jpg", o: "port" },
  { src: "/people/a12.webp", o: "land" },
  { src: "/people/a10.jpg", o: "port" },
  { src: "/people/a17.jpg", o: "land" },
  { src: "/people/a19.jpg", o: "port" },
  { src: "/people/a21.jpg", o: "wide" },
  { src: "/people/a14.jpg", o: "land" },
];

export const INDIA_MAP = "/people/india-map.png";

// A relationship is concluded when its years contain a closing year (YYYY–YYYY).
export const isClosed = (years) => /\d{4}\s*[-–]\s*\d{4}/.test(years);
